/**
 * Section: Lepro Add Product Swiper
 * File: assets/section-lepro-add-product-swiper.js
 *
 * Desktop：左右箭头控制产品轮播
 * Mobile：产品条 + 圆点切换 + 加购按钮
 */

(function () {
  'use strict';

  class ProductSwiper {
    constructor(section) {
      this.section = section;
      this.mobileStrip = section.querySelector('.hs-mobile-strip');
      this._init();
    }

    _init() {
      this._initProductsSlider();
      this._initStrip();
    }

    /**
     * PC端产品轮播：左右箭头滚动
     */
    _initProductsSlider() {
      const slider = this.section.querySelector('.hs-products-slider');
      if (!slider) return;

      const track   = slider.querySelector('.hs-products-slider__track');
      const prevBtn = slider.querySelector('.hs-products-slider__btn--prev');
      const nextBtn = slider.querySelector('.hs-products-slider__btn--next');

      if (!track) return;

      const getScrollAmount = () => {
        const item = track.querySelector('.hs-products-slider__item');
        if (!item) return 240;
        return item.offsetWidth + 16; // item width + gap
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }
    }

    /**
     * 移动端产品条：圆点切换 + 加购按钮
     */
    _initStrip() {
      if (!this.mobileStrip) return;

      this.mobileStrip.querySelectorAll('.hs-mobile-strip__dot').forEach((dot) => {
        dot.addEventListener('click', () => {
          this._activateStrip(parseInt(dot.dataset.dotIndex, 10));
        });
      });

      this.mobileStrip.querySelectorAll('.hs-mobile-strip__add-btn').forEach((btn) => {
        btn.addEventListener('click', () => this._addToCart(btn));
      });
    }

    /**
     * 切换产品条到指定索引，同步圆点高亮
     */
    _activateStrip(index) {
      if (!this.mobileStrip) return;
      this.mobileStrip.querySelectorAll('.hs-mobile-strip__slide').forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      this.mobileStrip.querySelectorAll('.hs-mobile-strip__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    /**
     * 加购：调用 /cart/add.js 并刷新购物车，加购成功后应用折扣码
     */
    _addToCart(btn) {
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      const couponCode = btn.dataset.coupon || '';
      btn.disabled = true;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map((s) => s.id)
        : [];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: window.location.pathname })
      })
        .then((res) => { if (!res.ok) throw new Error('Cart error'); return res.json(); })
        .then((data) => {
          const applyDiscount = couponCode ? this._applyDiscountCode(couponCode) : Promise.resolve();
          return applyDiscount.then(() => data);
        })
        .then((data) => {
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(data);
        })
        .catch((err) => console.error('[lepro-swiper] Add to cart failed:', err))
        .finally(() => { btn.disabled = false; });
    }

    /**
     * 通过 Storefront API 将折扣码追加到购物车
     */
    async _applyDiscountCode(couponCode) {
      try {
        await window.ShopifyConstant.applyCartDiscountCodes([couponCode]);
      } catch (err) {
        window.ShopifyConstant.reportCartDiscountError(err);
      }
    }

    destroy() {
      // 当前无需特别清理，事件绑定随 DOM 销毁自动释放
    }
  }

  /* ----------------------------------------------------------
     初始化 & 生命周期
  ---------------------------------------------------------- */

  function initSection(section) {
    if (section._productSwiper) return;
    section._productSwiper = new ProductSwiper(section);
  }

  function initAll() {
    document.querySelectorAll('.lepro-swiper-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ----------------------------------------------------------
     Shopify 主题编辑器支持
  ---------------------------------------------------------- */

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (section.classList.contains('lepro-swiper-section')) {
      if (section._productSwiper) section._productSwiper.destroy();
      delete section._productSwiper;
      initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const swiper = e.target._productSwiper;
    if (swiper) swiper.destroy();
    e.target._productSwiper = null;
  });
})();
